import projectsElements from "../../styles/components/projectsElements.module.scss";
import smartpay from "../../images/projects/smartpay.png";
import {Col, Row} from "react-bootstrap";
import redux from "../../images/technologies/redux.png";
import react from "../../images/technologies/react.png";
import {paths} from "../../storage/paths";
import {NavLink} from "react-router-dom";
import StatusCompletedButton from "../buttons/StatusCompletedButton";

function SmartPay() {
    return(
        <Col xxl={6} xl={6} lg={6} md={6} sm={6} xs={6} className={projectsElements.project}>
            <NavLink to={paths.SmartPay} className={projectsElements.link}>
                <img src={smartpay} className={projectsElements.projects_images}/>
                <h6>Smart Pay</h6>
            </NavLink>
            <Row>
                <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                    <StatusCompletedButton/>
                </Col>
                <Col xl={6} lg={6} md={6} sm={6} xs={12}>
                    <img src={react} className={projectsElements.projects_icons}/>
                    <img src={redux} className={projectsElements.projects_icons}/>
                </Col>
            </Row>
        </Col>
    );
}

export default SmartPay;